import React, { createContext } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { NamedRoutes } from '../routes'
import ListingServices from '../Services/Consumers/ListingServices'
import { useKeycloak } from '@react-keycloak/web'

const SubmissionViewContext = createContext({})

const SubmissionViewProvider = ({ id, children,isMs=false }) => {
  const intl = useIntl()
  let history = useHistory()
  const { keycloak } = useKeycloak()

  const [submissionData, setSubmissionData] = React.useState({})
  const [submissionDataLoading, setSubmissionDataLoading] = React.useState(false)

  const [listingRowsPerPage, setListingRowsPerPage] = React.useState(10)
  const [listingPage, setListingPage] = React.useState(-1)
  const [listingCount, setListingCount] = React.useState(0)


  React.useEffect(() => {
      if (!!id) {
        setListingPage(0)
      } else {
        history.push({
          pathname: NamedRoutes.invoices
        })
      }

    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  React.useEffect(() => {
      if (listingPage > -1) {
        handleSubmissionType()
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [listingPage, listingRowsPerPage])

  const handleChangeListingPage = (newPage) => {
    setListingPage(newPage)
  }

  const handleChangeListingRowsPerPage = (newRows) => {
    setListingRowsPerPage(+newRows)
    setListingPage(0)
  }

  const getSubmissionData = () => {
    if (!!keycloak?.authenticated && !!id) {
      setSubmissionDataLoading(true)
      ListingServices.getSubmissionData(id, {
        'uuid': id,
        'pageNo': listingPage + 1,
        'pageSize': listingRowsPerPage
      }, intl.formatMessage({ id: 'single.submission.Error' })).then((result) => {
        if (!!result && !!result.data) {
          setSubmissionData(result.data)
          setListingCount(result.data.metadata.totalCount)
        }
      }).then(() => {
        setSubmissionDataLoading(false)
      })
    }
  }


  const getMsSubmissionData = () => {
    if (!!keycloak?.authenticated && !!id) {
      setSubmissionDataLoading(true)
      ListingServices.getMsSubmissionData(id, {
        'uuid': id,
        'PageNo': listingPage + 1,
        'PageSize': listingRowsPerPage
      }, intl.formatMessage({ id: 'single.submission.Error' })).then((result) => {
        if (!!result && !!result.data) {
          setSubmissionData(result.data)
          setListingCount(result.data.metadata.totalCount)
        }
      }).then(() => {
        setSubmissionDataLoading(false)
      })
    }
  }

  
  // check if submission is type SP or Ms
  const handleSubmissionType=()=>{
    if(isMs) getMsSubmissionData()
    else getSubmissionData()
  }
  
  return (
    <SubmissionViewContext.Provider value={{
      id,
      submissionData,
      submissionDataLoading,
      getSubmissionData,

      listingCount,
      listingPage,
      listingRowsPerPage,
      handleChangeListingPage,
      handleChangeListingRowsPerPage,
    }}>
      {children}
    </SubmissionViewContext.Provider>
  )
}
const SubmissionViewConsumer = SubmissionViewContext.Consumer

export { SubmissionViewProvider, SubmissionViewConsumer }
